import React, { memo, useCallback, useEffect } from 'react';
import {FormBlocks} from './FormBlocks';
import {formFieldsAttributes} from '../../FormBuilderFunctions/FieldProps';
// import Datetime from 'react-datetime';
import moment from 'moment';
import {getDateFormat} from '../../../../Utils/UserFunctions';
import {isSet} from '../../../../Utils/CommonFunctions';
import MomentUtils from '@date-io/moment';
import {
  DateTimePicker,
  MuiPickersUtilsProvider,
} from '@material-ui/pickers';
import { ThemeProvider, createTheme } from "@material-ui/core/styles";
// cyan lightBlue
import blue from "@material-ui/core/colors/blue";


const detectDateFormat = (dateString) => {
  const dateFormats = [
    getDateFormat('DateTime'),
    'YYYY-MM-DD HH:mm:ss.S'
  ];
  const matchedFormat = dateFormats.find(format => moment(dateString, format, true).isValid());
  return matchedFormat || 'Unknown format';
};


const DatePick = (props)=>{
  const  {
    item,
    className,
    validationForms,
    sectionType,
    fieldObj
  } = props;
  const getDateTimeFormat =  getDateFormat('DateTime');//'YYYY-MM-DD HH:mm:ss.S';
  // const putDateTimeFormat = 'YYYY-MM-DD HH:mm:ss.S';
  useEffect(()=>{
      if(!item.overridden && props.layoutForms){
        let defaultValue = null;
        // console.log('item.selectedValue',isSet(item.default_value,null),item.overridden,isSet(item.selectedValue,null));
        if(isSet(item.default_value,null)!==null && !item.overridden && isSet(item.selectedValue,null)===null){
            const splitDefautDate = item.default_value.split(' ');
            // console.log('splitDefautDate',splitDefautDate);
            if(splitDefautDate[0]==='Today'){
              defaultValue = moment().format(getDateTimeFormat);
            }else{
              defaultValue = moment().subtract(splitDefautDate[0], splitDefautDate[1]).format(getDateTimeFormat);
            }
        }
        // console.log('defaultValue',defaultValue,item);
        if(defaultValue!==null){
          props.onChangeInputAction(fieldObj,defaultValue,'date');
        }
      }
  },[item.overridden]);
  
  const onChangeDate = useCallback((moment)=>{
    if (isSet(moment,null)!==null &&  typeof moment.format === "function" && props.layoutForms) {
        props.onChangeInputAction(fieldObj,moment.format(getDateTimeFormat),
        'date');
      }else if(props.layoutForms || isSet(moment,null)===null){
        // console.log('defff',(isSet(moment,null)===null)?null:moment.format(putDateTimeFormat));
          props.onChangeInputAction(fieldObj,
            (isSet(moment,null)===null)?null:moment.format(getDateTimeFormat),
            'date');
      } 
   })
   const materialTheme = createTheme({
    palette: {primary: blue},
  });

    const attr = formFieldsAttributes(
      {...item,default_value:null,className:className
    },validationForms);

    let readonlyVal = false;
    if(attr.fieldAttributes && attr.fieldAttributes.readOnly) {
      readonlyVal = attr.fieldAttributes.readOnly;
    }

  // console.log('dispValue',attr.value)
  const displayDate =  (isSet(attr.value,null)!==null && isSet(attr.value,null)!=='Invalid date')?moment(attr.value, detectDateFormat(attr.value), true):''
  // console.log('displayDate',displayDate,attr.value);
  return (
    <FormBlocks attr={attr} {...props} item={item} sectionType={sectionType}>
      <ThemeProvider theme={materialTheme}>
          <MuiPickersUtilsProvider utils={MomentUtils} >
            <DateTimePicker
              fullWidth
              keyboard
              clearable
              ampm={false}
              margin="normal"
              defaultValue={null} 
              value={isSet(displayDate,null)}
              // disablePast
              onChange={onChangeDate}
              label=""
              // clearable={true}
              InputProps={{
                className:'form-control',
                style: {fontSize: '0.8rem'},
                disableUnderline: true,
                ...attr.fieldAttributes,
                autoComplete:'off',
              }}
              readOnly={readonlyVal} 
              //  variant={'inline'}       
              // showTodayButton 
              format={getDateFormat('DateTime')}
              autoOk={true}
              className="MuiFormControl-Custom"
              views={['date','hours','minutes','seconds']}
              />
            </MuiPickersUtilsProvider>
        </ThemeProvider>
    </FormBlocks>
  )  
}


DatePick.defaultProps = {
className:'form-control'
}


const isDiffProps = (prevProps,nextProps)=>{
  if(prevProps.item===nextProps.item && prevProps.validationForms===nextProps.validationForms && prevProps.item.access_mode===nextProps.item.access_mode && prevProps.item.required===nextProps.item.required){
    return true;
  }
}

export default memo(DatePick,isDiffProps);
